import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import appPlugin from '@backstage/plugin-app';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { githubAuthApiRef, type SignInPageProps } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { navModule } from './modules/nav';

// No `name` field → overrides the default sign-in-page extension.
const githubSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: SignInPageProps) => (
      <SignInPage
        {...props}
        providers={[
          {
            id: 'github-auth-provider',
            title: 'GitHub',
            message: 'Sign in using GitHub',
            apiRef: githubAuthApiRef,
          },
        ]}
      />
    ),
  },
});

const signInOverride = appPlugin.withOverrides({
  extensions: [githubSignInPage],
});

export default createApp({
  features: [catalogPlugin, navModule, signInOverride],
});
